var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item",class:{ clickable: _vm.clickable, 'full-width': _vm.windowWidth < 1200 }},[_c('div',{staticClass:"align-items-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }